var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5776_114932)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5776_114932",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5776_114932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.4721C0 5.85814 5.35814 0.5 11.9721 0.5C18.586 0.5 23.9442 5.85814 23.9442 12.4721C23.9442 19.086 18.586 24.4442 11.9721 24.4442C5.35814 24.4302 0 19.0721 0 12.4721Z",
    fill: "#5865F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3582 7.60174C16.3396 7.14128 15.2791 6.8064 14.1768 6.625C14.0372 6.87616 13.8838 7.19709 13.7721 7.46221C12.6 7.28081 11.414 7.28081 10.2419 7.46221C10.1163 7.16919 9.97678 6.89012 9.82329 6.625C8.72096 6.8064 7.64655 7.14128 6.6419 7.6157C4.63259 10.6157 4.08841 13.532 4.35352 16.4203C5.53957 17.2994 6.8512 17.9692 8.2605 18.3878C8.58143 17.9552 8.8605 17.5087 9.09771 17.0343C8.63724 16.8669 8.20469 16.6576 7.78608 16.4064C7.89771 16.3227 7.99539 16.239 8.10701 16.1552C10.5768 17.3273 13.4512 17.3273 15.921 16.1552C16.0326 16.239 16.1303 16.3227 16.2419 16.4064C15.8233 16.6576 15.3768 16.8669 14.9163 17.0343C15.1535 17.5087 15.4326 17.9552 15.7535 18.3878C17.1628 17.9552 18.4884 17.2994 19.6605 16.4203C19.9675 13.0715 19.1024 10.1692 17.3582 7.60174ZM9.43259 14.6343C8.66515 14.6343 8.0512 13.9366 8.0512 13.0855C8.0512 12.2343 8.66515 11.5227 9.43259 11.5227C10.214 11.5227 10.8279 12.2203 10.8279 13.0855C10.814 13.9366 10.214 14.6343 9.43259 14.6343ZM14.5675 14.6343C13.8 14.6343 13.1861 13.9366 13.1861 13.0855C13.1861 12.2343 13.8 11.5227 14.5675 11.5227C15.3489 11.5227 15.9628 12.2203 15.9489 13.0855C15.9349 13.9506 15.3349 14.6343 14.5675 14.6343Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5776_114932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscIcon);
export default __webpack_public_path__ + "static/media/disc_icon.3847bc58d03d8a493176d2008576f0a5.svg";
export { ForwardRef as ReactComponent };